
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import useAuth from "@/hooks/useAuth";
import { TerraceFormValues } from '../types';
import { SubmissionService, type SubmissionData } from '@/lib/services/submissionService';

export const useTerraceSubmission = (
  extractedCoordinates?: {lat: number, lng: number} | null,
  selectedPhotoUrl?: string | null,
  extractedPlaceId?: string | null,
  extractedPlaceName?: string | null,
  originalMapsUrl?: string | null
) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (data: TerraceFormValues) => {
    try {
      console.log("Auth state during submission:", { 
        user: user, 
        userId: user?.id, 
        isAuthenticated: !!user 
      });

      const submissionData: SubmissionData = {
        extractedCoordinates,
        selectedPhotoUrl,
        extractedPlaceId,
        extractedPlaceName,
        originalMapsUrl
      };

      await SubmissionService.submitTerrace(data, submissionData, user?.id);

      toast.success("Thank you! Your terrace submission is being reviewed.");
      navigate("/");
    } catch (error) {
      console.error("Form submission error:", error);
      const errorMessage = error instanceof Error ? error.message : "An unexpected error occurred. Please try again.";
      toast.error(errorMessage);
    }
  };

  return { onSubmit };
};
